import useSize from "@/libs/shared/hooks/useSize";
import type { ReactNode, RefObject } from "react";

const Resizer = ({
  children,
  height,
}: {
  height: number;
  children: (width: number) => ReactNode;
}) => {
  const {
    ref,
    size: { width },
  } = useSize();

  return (
    <div
      ref={ref as RefObject<HTMLDivElement>}
      style={{ position: "relative", width: "100%", height }}
    >
      <div style={{ position: "absolute", top: 0, left: 0, height, width }}>
        {children(width)}
      </div>
    </div>
  );
};

export default Resizer;
